var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { FileUploadService } from "~/services/file-service/file-upload.service";
import { Dependencies } from "~/core/decorator";
import { CaseRepaymentService } from '~/services/domain-service/case-repayment.service';
var RepaymentConfirmationDetail = /** @class */ (function (_super) {
    __extends(RepaymentConfirmationDetail, _super);
    function RepaymentConfirmationDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            confirmState: '',
            confirmRemark: '',
            id: ''
        };
        _this.fileList = [];
        _this.srcList = [];
        _this.rules = {
            confirmState: { required: true, message: '请选择确认状态！' }
        };
        _this.submitLoading = false;
        return _this;
    }
    RepaymentConfirmationDetail.prototype.emitClose = function () {
        var form = this.$refs['data'];
        form.resetFields();
    };
    RepaymentConfirmationDetail.prototype.emitRefreshList = function () { };
    RepaymentConfirmationDetail.prototype.submit = function () {
        var _this = this;
        var from = this.$refs['data'];
        from.validate(function (valid) {
            if (!valid)
                return;
            _this.submitLoading = true;
            _this.model.id = _this.rowData.id;
            _this.caseRepaymentService.confirmCaseRepaymentApply(_this.model).subscribe(function (data) {
                _this.submitLoading = false;
                _this.$message.success('操作成功！');
                _this.emitClose();
                _this.emitRefreshList();
            }, function (error) { _this.submitLoading = false; });
        });
    };
    RepaymentConfirmationDetail.prototype.imageFileList = function () {
        var _this = this;
        this.srcList = [];
        this.fileList = [];
        if (!this.rowData.imageUrl)
            return;
        this.fileUploadService.getAllUploadFileByIds(this.rowData.imageUrl).subscribe(function (data) {
            _this.fileList = data;
            _this.fileList.forEach(function (item) {
                _this.srcList.push(item.url);
            });
        });
    };
    __decorate([
        Dependencies(FileUploadService)
    ], RepaymentConfirmationDetail.prototype, "fileUploadService", void 0);
    __decorate([
        Dependencies(CaseRepaymentService)
    ], RepaymentConfirmationDetail.prototype, "caseRepaymentService", void 0);
    __decorate([
        Prop()
    ], RepaymentConfirmationDetail.prototype, "rowData", void 0);
    __decorate([
        Emit('close')
    ], RepaymentConfirmationDetail.prototype, "emitClose", null);
    __decorate([
        Emit('refreshList')
    ], RepaymentConfirmationDetail.prototype, "emitRefreshList", null);
    RepaymentConfirmationDetail = __decorate([
        Component({
            components: {}
        })
    ], RepaymentConfirmationDetail);
    return RepaymentConfirmationDetail;
}(Vue));
export default RepaymentConfirmationDetail;
